<template>
    <div style="padding:10px;height:100vh;overflow-y:auto;box-sizing:border-box;">
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">商品</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadqc" type="primary">下载期初商品模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="downloadqczz"
                    type="primary">下载期初商品证照模板</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportQc('导入期初商品')"
                    type="primary">导入期初商品</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportZz('导入期初商品证照')"
                    type="primary">导入期初商品证照</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">供应商</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadgys" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="downloadgyszz"
                    type="primary">下载期初供应商证照模板</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportGys('导入期初供应商')"
                    type="primary">导入期初供应商</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportGyszz('导入期初供应商证照')"
                    type="primary">导入期初供应商证照</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>

        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">客户</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadkh" type="primary">下载期初客户模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="downloadkhzz"
                    type="primary">下载期初客户证照模板</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportkh('导入期初客户')"
                    type="primary">导入期初客户</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportkhzz('导入期初客户证照')"
                    type="primary">导入期初客户证照</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">库存</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadkc" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportkc('导入期初库存')"
                    type="primary">导入期初库存</el-button>
                <el-button size="mini" icon="el-icon-download" @click="downloadkcwj" type="primary">下载库存质检文件模板</el-button>
                <el-button size="mini" icon="el-icon-folder-add" @click="exportkcwj('导入期初库存质检文件')"
                    type="primary">导入期初库存质检文件</el-button>
                    
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">采购单据</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadqccgdj" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="exportqQcgdj('导入期初采购单据')" type="primary">
                    导入期初采购单据</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">销售单据</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadqcxsdj" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="exportqQcxsdj('导入期初销售单据')" type="primary">
                    导入期初销售单据</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">委托书</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadwts" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="exportWts('导入委托书')" type="primary">
                    导入委托书</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">供应商账款</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadgyszk" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="exportqQgyszk('导入供应商账款')" type="primary">
                    导入供应商账款</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">客户账款</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadkhzk" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="exportqQkhzk('导入客户账款')" type="primary">
                    导入客户账款</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">零售记录</h1>
                <el-button size="mini" icon="el-icon-download" @click="downloadLsjl" type="primary">下载模板</el-button>
                <el-button size="mini" icon="el-icon-download" @click="exportLsjl('导入零售记录')" type="primary">
                    导入零售记录</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
            <initDataUpload :url="url" :errorUrl="errorUrl" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'initDataGl',
    components: {},
    data() {
        return {
            dialogVisible: false,// 弹窗
            requesUrl: '',// 请求地址
            limit: 2,// 上传文件数量
            fileList: [],// 上传文件列表
            importType: '',// 导入类型
            url: '',// 导入地址
            title: "",// 弹窗标题
            errorUrl:"",//导入失败地址
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(refresh) {
            this.dialogVisible = false
            // if (refresh) this.getDataList()
        },
        // 商品
        downloadqc() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/GSPgoods/downGoodExcel`
        },
        // 商品证照
        downloadqczz() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/GSPgoods/downGoodLicenceExcel`
        },
        // 供应商
        downloadgys() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspSupplier/downSupExcel`
        },
        // 供应商证照
        downloadgyszz() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspSupplier/downSupLicenceExcel`
        },
        // 期初客户
        downloadkh() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspCustomer/downCusExcel`
        },
        // 期初客户证照
        downloadkhzz() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspCustomer/downSupLicenceExcel`
        },
        // 期初库存
        downloadkc() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/bgStock/downStockExcel`
        },
        // 期初库存质检文件
        downloadkcwj(){
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/bgStock/downStockFileExcel`
        },
        // 期初采购单据
        downloadqccgdj() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/klPuorder/importTemplate`
        },
        // 期初销售单据
        downloadqcxsdj() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/klSuorder/importTemplate`
        },
        // 委托书
        downloadwts() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/counterpartySalesman/downLicenceExcel`
        },
        // 供应商账款
        downloadgyszk() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/currentReset/downSupAccountExcel`
        },
        // 客户账款
        downloadkhzk() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/currentReset/downCusAccountExcel`
        },
        // 零售记录下载
        downloadLsjl() {
            window.location.href = `${this.$store.getters.getConfig.requestUrl}/retail/downloadRetailTemplate`
        },
        // 商品
        exportQc(title) {
            this.title = title
            this.importType = 'initUpload'
            this.url = 'GSPgoods/exportinit'
            this.dialogVisible = true
        },
        // 商品证照
        exportZz(title) {
            this.title = title
            this.importType = 'importUpload'
            this.url = 'GSPgoods/exportLicence'
            this.dialogVisible = true
        },
        //  供应商
        exportGys(title) {
            this.title = title
            this.importType = 'importUploadGys'
            this.url = 'gspSupplier/exportinit'
            this.dialogVisible = true
        },
        // 供应商证照
        exportGyszz(title) {
            this.title = title
            this.importType = 'importUploadGyszz'
            this.url = 'gspSupplier/exportSupLicence'
            this.dialogVisible = true
        },
        // 期初客户
        exportkh(title) {
            this.title = title
            this.importType = 'importUploadkh'
            this.url = 'gspCustomer/exportinit'
            this.dialogVisible = true
        },
        // 期初客户证照
        exportkhzz(title) {
            this.title = title
            this.importType = 'importUploadkhzz'
            this.url = 'gspCustomer/exportCusLicence'
            this.dialogVisible = true
        },
        // 期初库存
        exportkc(title) {
            this.title = title
            this.importType = 'importUploadkc'
            this.url = 'bgStock/exportStockInit'
            this.dialogVisible = true
        },
        // 期初库存质检文件
        exportkcwj(title) {
            this.title = title
            this.importType = 'bgStockimportStockFile'
            this.errorUrl='bgStock/exportStockFileFail'
            this.dialogVisible = true
        },
        // 期初采购单据
        exportqQcgdj(title) {
            this.title = title
            this.importType = 'importUpQc'
            this.url = 'klPuorder/upload'
            this.dialogVisible = true
        },
        // 期初销售单据
        exportqQcxsdj(title) {
            this.title = title
            this.importType = 'importUpQcxs'
            this.url = 'klSuorder/upload'
            this.dialogVisible = true
        },
        // 委托书
        exportWts(title) {
            this.title = title
            this.importType = 'importUpWts'
            this.url = 'counterpartySalesman/importLicence'
            this.errorUrl = 'counterpartySalesman/exportLicenceFail'
            this.dialogVisible = true
        },
        // 供应商账款
        exportqQgyszk(title) {
            this.title = title
            this.importType = 'importUpGyszk'
            this.url = 'currentReset/exportSupAccount'
            this.dialogVisible = true
        },
        // 客户账款
        exportqQkhzk(title) {
            this.title = title
            this.importType = 'importUpKhzk'
            this.url = 'currentReset/exportCusAccount'
            this.dialogVisible = true
        },
        // 零售记录导入
        exportLsjl(title) {
            this.title = title
            this.importType = 'retailimportRetailExcel'
            this.errorUrl='retail/exportRetailFail'
            this.dialogVisible = true
        }

    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl; // 获取请求地址
    },
    mounted() { }
};
</script>
<style scoped></style>s